import { InternalError } from './internal.error';

export interface JobValidationFieldError {
  path: string;
  code?: string;
  message?: string;
  info?: { limit?: number };
}

const FIELD_LABELS: Record<string, string> = {
  '/street1': 'Street address',
  '/city': 'City',
  '/state': 'State',
  '/postalCode': 'ZIP code',
  '/locationContext': 'Location type',
  '/travelExpectations': 'Travel expectations',
};

function labelFor(path: string): string {
  return FIELD_LABELS[path] ?? path.replace(/^\//, '');
}

function formatField(field: JobValidationFieldError): string {
  const label = labelFor(field.path);
  if (field.code === 'maxLength' && typeof field.info?.limit === 'number') {
    return `${label} must be ${field.info.limit} characters or fewer`;
  }
  if (field.message) {
    return `${label}: ${field.message}`;
  }
  return label;
}

export function formatJobValidationMessage(fields: JobValidationFieldError[]): string {
  if (fields.length === 0) return 'Some job fields are invalid.';
  if (fields.length === 1) return `${formatField(fields[0])}.`;
  return `Some fields need attention: ${fields.map(formatField).join('; ')}.`;
}

export class JobValidationError extends InternalError {
  public readonly fields: JobValidationFieldError[];

  constructor(fields: JobValidationFieldError[], status?: number | null) {
    super('Job request body failed validation', {
      status,
      data: { fields },
    });
    this.fields = fields;
  }
}
